import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getUserData } from "../../utils/localStorage";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { getLead, getLeadSource, getLeadType, getUserLead } from "../../services/leads";
import { errorMessage } from "../../utils/alertMessage";
import { getBank, getBanker, getBranch, getLoanFile, getLoanFileStatus, getProduct, getStateWiseCities, getUser } from "../../services/userMasterUser";
import { MultiSelect } from "primereact/multiselect";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const RetailPipeline = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const [activeView, setActiveView] = useState("loan");

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 3); // subtract 7 days to current date

  const [startDateValue, setStartDateValue] = useState(new Date(initialStartDate));
  const [endDateValue, setEndDateValue] = useState(new Date());

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [stateCityList, setStateCityList] = useState({});

  const recordTypeSelection = [
    { label: "CreatedOn", value: "CreatedOn" },
    { label: "LeadOn", value: "LeadOn" },
    { label: "FollowUpOn", value: "FollowUpOn" },
    { label: "ClosedOn", value: "ClosedOn" },
    { label: "RequestOn", value: "RequestOn" },
    { label: "SanctionOn", value: "SanctionOn" },
    { label: "DisbursedOn", value: "DisbursedOn" },
  ]

  const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  const [leadTypeList, setLeadTypeList] = useState([])
  const [typeOfLead, setTypeOfLead] = useState('')

  const [leadData, setLeadData] = useState([])

  const [branchDataList, setBranchDataList] = useState([])
  const [productDataList, setProductDataList] = useState([])
  const [branchDataValue, setBranchDataValue] = useState("")
  const [productDataValue, setProductDataValue] = useState("")
  const [userDataFilter, setUserDataFilter] = useState("");

  const [stateValue, setStateValue] = useState('')
  const [cityValue, setCityValue] = useState('')

  const [userDataIds, setUserDataIds] = useState([]);

  const citiesList = stateCityList[stateValue] || [];

  useEffect(() => {

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
          fetchData({
            ...typeData,
            recordType: "CreatedOn",
            startDate: startDateValue,
            endDate: endDateValue,
            leadTypeIn: response.data
          });
        }
      })
      .catch(() => errorMessage());


    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));


    const typeBranchData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getBranch(typeBranchData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const branchData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setBranchDataList(branchData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })


    const typeProductData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getProduct(typeProductData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const productData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setProductDataList(productData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    const userData = {
      searchBy: "",
      searchText: "",
      limit: 1000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      userTypeIdIn: [],
      roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
      statusIn: []

    };

    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
        }
      })
      .catch(() => {
        errorMessage();
      })

  }, [])

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],

    recordType: recordTypeValue,
    startDate: "",
    endDate: "",
    leadTypeIn: [], // leadType ka selection
    userIdIn: []
  };

  const fetchData = (data) => {

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);


          setLeadData(rawData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  useEffect(() => {

    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    const hasValidFilter =
      recordTypeValue ||
      typeOfLead ||
      startDateValue ||
      endDateValue ||
      stateValue ||
      cityValue ||
      branchDataValue ||
      productDataValue ||
      userDataFilter;

    if (!hasValidFilter) return;

    fetchData({
      ...typeData,
      recordType: recordTypeValue,
      startDate,
      endDate,
      leadTypeIn: [typeOfLead],
      branchIdIn: branchDataValue ? branchDataValue : [],
      productIdIn: productDataValue ? productDataValue : [],
      userIdIn: userDataFilter ? userDataFilter : [],
      addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] }
    });

  }, [recordTypeValue, typeOfLead, startDateValue, endDateValue, branchDataValue, productDataValue, userDataFilter]);

  // const leadStatusMap = leadData.reduce((acc, item) => {
  //   const status = item.lead.status;

  //   if (!acc[status]) {
  //     acc[status] = [];
  //   }

  //   acc[status].push(item.lead);

  //   return acc;
  // }, {});

  // Loan Leads
  const LoanLeads = (leadData || []).filter(
    (item) =>
      item?.lead?.typeOfLead === "loan_type_lead" ||
      item?.lead?.typeOfLead === "Loan"
  );

  // Project Report Leads
  const ProjectReportLeads = (leadData || []).filter(
    (item) =>
      item?.lead?.typeOfLead === "project_report_tev_study_pitch_deck" ||
      item?.lead?.typeOfLead === "Project report - Leads"
  );

  // console.log("ProjectReportLeads", ProjectReportLeads);

  // Group By Status
  // const leadStatusMap2 = Object.groupBy(
  //   leadData || [],
  //   (item) => item?.lead?.status
  // );


  const retailUnassignedLoanCount = LoanLeads?.filter(
    (item) => (item?.lead?.amount || 0) <= 10000000 // 1 Cr
  );

  const loanLeadStatusMap = Object.groupBy(retailUnassignedLoanCount, item => item.lead.status);

  const totalLoanAmount = retailUnassignedLoanCount
    ?.reduce((sum, item) => sum + (item?.lead?.amount || 0), 0);


  const loanResult = Object.entries(loanLeadStatusMap).map(([status, items]) => ({
    status,
    amount: items.reduce(
      (sum, item) => sum + (item?.lead?.amount || 0),
      0
    ),
    count: items.length
  }));


  const inProcessLoanData = loanResult.find(
    (item) => item.status?.toLowerCase() === "in process"
  );

  const disbursementLoanData = loanResult.find(
    (item) => item.status?.toLowerCase() === "disbursement"
  );

  // Project Report

  const retailUnassignedProjectReportCount = ProjectReportLeads?.filter(
    (item) => (item?.lead?.amount || 0) <= 10000000 // 1 Cr
  );

  const projectReportLeadStatusMap = Object.groupBy(retailUnassignedProjectReportCount, item => item.lead.status);

  const totalProjectReportAmount = retailUnassignedProjectReportCount
    ?.reduce((sum, item) => sum + (item?.lead?.amount || 0), 0);


  const projectReportResult = Object.entries(projectReportLeadStatusMap).map(([status, items]) => ({
    status,
    amount: items.reduce(
      (sum, item) => sum + (item?.lead?.amount || 0),
      0
    ),
    count: items.length
  }));


  const inProcessProjectReportData = projectReportResult.find(
    (item) => item.status?.toLowerCase() === "in process"
  );



  function formatIndianShort(value) {
    if (value == null || isNaN(value)) return "";

    const num = Number(value);

    if (num >= 10000000) {
      return (num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1) + "Cr";
    }

    if (num >= 100000) {
      return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + "L";
    }

    return num.toLocaleString("en-IN");
  }

  const OrderStatusColors = [
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#000",
  ];

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div class="sec-hdr">
                      <div class="sec-ico">
                        📥
                      </div>
                      <div>
                        <div class="sec-title">Lead Status — Lead Box</div>
                        <div class="sec-sub">No. of leads · Total loan amounts</div>
                      </div>
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px",  marginBottom:10 }}>
                        <button
                          className={`btn ${activeView === "loan" ? "btn-primary" : "btn-light"}`}
                          onClick={() => setActiveView("loan")}
                        >
                          Loans
                        </button>

                        <button
                          className={`btn ${activeView === "project" ? "btn-primary" : "btn-light"}`}
                          onClick={() => setActiveView("project")}
                        >
                          Project Report
                        </button>
                      </div>

                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b", cursor: "pointer" }}
                      ></i>
                    </div>
                    {isFilterVisible && <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      <div className="row">

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={leadTypeList}
                            value={typeOfLead}
                            placeholder="Select Lead Type"
                            onChange={(e) => {
                              setTypeOfLead(e.value);
                            }}
                          />
                        </div>

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={recordTypeSelection}
                            value={recordTypeValue}
                            placeholder="Select Record Type"
                            onChange={(e) => {
                              setRecordTypeValue(e.value);
                            }}
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Calendar
                            value={startDateValue}
                            onChange={(e) => {
                              const start = e.value;
                              setStartDateValue(start);

                              if (!endDateValue) {
                                setEndDateValue(new Date()); // default today
                              }
                            }}
                            dateFormat="dd/mm/yy"
                            placeholder="Start Date"
                            maxDate={endDateValue ? endDateValue : new Date()}
                            showIcon
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Calendar
                            value={endDateValue}
                            onChange={(e) => setEndDateValue(e.value)}
                            dateFormat="dd/mm/yy"
                            placeholder="End Date"
                            minDate={startDateValue}
                            showIcon
                            style={{ width: "100%" }} />
                        </div>
                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            value={stateValue}
                            onChange={(e) => {
                              setStateValue(e.value);
                              setCityValue([])
                            }
                            }
                            options={stateCitiesList}
                            optionLabel="label"
                            placeholder="Select a State"
                            filter
                            filterDelay={400}
                          />
                        </div>

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={cityValue}
                            onChange={(e) => setCityValue(e.value)}
                            options={citiesList}
                            placeholder="Select City"
                          />
                        </div>

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={branchDataValue}
                            onChange={(e) => setBranchDataValue(e.value)}
                            options={branchDataList}
                            optionLabel="label"
                            placeholder="Select Branch"
                          />
                        </div>
                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={productDataValue}
                            onChange={(e) => setProductDataValue(e.value)}
                            options={productDataList}
                            optionLabel="label"
                            placeholder="Select Product"
                          />
                        </div>
                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={userDataFilter}
                            onChange={(e) => setUserDataFilter(e.value)}
                            options={userDataIds}
                            optionLabel="label"
                            placeholder="Select User"
                          />
                        </div>
                      </div>


                    </div>}

                    {activeView === "loan" && (
                      <>
                        {/* Loan KPI Row */}
                    <div className="kpi-row">
                      <div className="kpi" style={{ borderLeftColor: "#E87010" }}>
                        <div className="kpi-lbl">Total Leads</div>
                        <div className="kpi-val">{retailUnassignedLoanCount.length}</div>
                      </div>
                      <div className="kpi" style={{ borderLeftColor: "#16A869" }}>
                        <div className="kpi-lbl">Total Amount</div>
                        <div className="kpi-val">₹{formatIndianShort(totalLoanAmount)}</div>
                      </div>
                      <div className="kpi" style={{ borderLeftColor: "#D63B3B" }}>
                        <div className="kpi-lbl">In Process</div>
                        <div className="kpi-val">{inProcessLoanData?.count}</div>
                        <div className="kpi-dn">₹{formatIndianShort(inProcessLoanData?.amount || 0)}</div>
                      </div>
                      <div className="kpi" style={{ borderLeftColor: "#1A4DB5" }}>
                        <div className="kpi-lbl">Disbursed</div>
                        <div className="kpi-val">{disbursementLoanData?.count}</div>
                            <div className="kpi-dn">₹{formatIndianShort(disbursementLoanData?.amount || 0)}</div>
                      </div>

                    </div>

                        <div
                          className="kpi-row-second"
                          style={{
                            marginTop: 10,
                            marginBottom: 10,
                          }}
                        >
                          {loanResult.map((item, index) => (
                            <div
                              key={item.status}
                              className="kpi"
                              style={{
                                borderLeftColor:
                                  OrderStatusColors[index % OrderStatusColors.length],
                              }}
                            >
                              <div className="kpi-lbl">
                                {item.status} - {item.count}
                              </div>

                              <div className="kpi-val">
                                ₹{formatIndianShort(item.amount)}
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* Loan Table */}
                    {/*<div className="dataview-demo">
                      <div className="card">
                        <DataTable
                          value={loanResult}
                          lazy
                          paginator
                          paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          rows={50}
                          rowsPerPageOptions={[50, 100, 150]}
                          dataKey="id"
                          className="p-datatable-customers client-table-design"
                          resizableColumns
                          columnResizeMode="fit"
                          stripedRows
                        >

                          <Column
                            field="status"
                            header="Stage"
                            className="simple-table"
                            body={(rowData) => (
                              <span>
                                {rowData.status}
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="count"
                            header="No. of Leads"
                            className="simple-table"
                            body={(rowData) => (
                              <span>
                                {rowData.count}
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="amount"
                            header="Total Loan Amount (₹)"
                            className="simple-table"
                            body={(rowData) => (
                              <span className="colored1">
                                ₹{formatIndianShort(rowData.amount)}
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="amount"
                            header="Avg Loan (₹)"
                            className="simple-table"
                            body={(rowData) => (
                              <span className="colored2">
                                ₹{
                                  formatIndianShort(
                                    rowData.count
                                      ? rowData.amount / rowData.count
                                      : 0
                                  )
                                }
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="amount"
                            header="% of Total"
                            className="simple-table"
                            body={(rowData) => (
                              <span>
                                {totalLoanAmount
                                  ? ((rowData.amount / totalLoanAmount) * 100).toFixed(2)
                                  : 0}
                                %
                              </span>
                            )}
                          ></Column>

                        </DataTable>
                      </div>
                    </div>*/}
                      </>
                    )}
                    
                    {activeView === "project" && (
                      <>
                        {/* Project KPI Row */}
                    <div className="kpi-row">
                      <div className="kpi" style={{ borderLeftColor: "#E87010" }}>
                        <div className="kpi-lbl">Total Leads</div>
                        <div className="kpi-val">{retailUnassignedProjectReportCount.length}</div>
                      </div>
                      <div className="kpi" style={{ borderLeftColor: "#16A869" }}>
                        <div className="kpi-lbl">Total Amount</div>
                        <div className="kpi-val">₹{formatIndianShort(totalProjectReportAmount)}</div>
                      </div>
                      <div className="kpi" style={{ borderLeftColor: "#D63B3B" }}>
                        <div className="kpi-lbl">In Process</div>
                        <div className="kpi-val">{inProcessProjectReportData?.count}</div>
                        <div className="kpi-dn">₹{formatIndianShort(inProcessProjectReportData?.amount || 0)}</div>
                      </div>
                      <div className="kpi" style={{ borderLeftColor: "#1A4DB5" }}>
                        <div className="kpi-lbl">Disbursed</div>
                        <div className="kpi-val"></div>
                      </div>

                    </div>

                        <div
                          className="kpi-row-second"
                          style={{
                            marginTop: 10,
                            marginBottom: 10,
                          }}
                        >
                          {projectReportResult.map((item, index) => (
                            <div
                              key={item.status}
                              className="kpi"
                              style={{
                                borderLeftColor:
                                  OrderStatusColors[index % OrderStatusColors.length],
                              }}
                            >
                              <div className="kpi-lbl">
                                {item.status} - {item.count}
                              </div>

                              <div className="kpi-val">
                                ₹{formatIndianShort(item.amount)}
                              </div>
                            </div>
                          ))}
                        </div>

                    {/*<div className="dataview-demo">
                      <div className="card">
                        <DataTable
                          value={projectReportResult}
                          lazy
                          paginator
                          paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          rows={50}
                          rowsPerPageOptions={[50, 100, 150]}
                          dataKey="id"
                          className="p-datatable-customers client-table-design"
                          resizableColumns
                          columnResizeMode="fit"
                          stripedRows
                        >
                          
                          <Column
                            field="status"
                            header="Status"
                            className="simple-table"
                            body={(rowData) => (
                              <span>
                                {rowData.status}
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="count"
                            header="No. of Leads"
                            className="simple-table"
                            body={(rowData) => (
                              <span>
                                {rowData.count}
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="amount"
                            header="Total Loan Amount (₹)"
                            className="simple-table"
                            body={(rowData) => (
                              <span className="colored1">
                                ₹{formatIndianShort(rowData.amount)}
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="amount"
                            header="Avg Loan (₹)"
                            className="simple-table"
                            body={(rowData) => (
                              <span className="colored2">
                                ₹{
                                  formatIndianShort(
                                    rowData.count
                                      ? rowData.amount / rowData.count
                                      : 0
                                  )
                                }
                              </span>
                            )}
                          ></Column>

                          <Column
                            field="amount"
                            header="% of Total"
                            className="simple-table"
                            body={(rowData) => (
                              <span>
                                {totalLoanAmount
                                  ? ((rowData.amount / totalLoanAmount) * 100).toFixed(2)
                                  : 0}
                                %
                              </span>
                            )}
                          ></Column>

                        </DataTable>
                      </div>
                    </div>*/}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default RetailPipeline;
